import React, { useRef } from 'react';

import { MainEditor } from '../MainEditor/MainEditor.js';

import * as theEditorsStyles from '../TheEditors.css';
import * as styles from './SingleEditor.css';

const SingleEditor = () => {
    const editorRef = useRef(null);
    return (
        <div className={styles.SingleEditor}>
            <div className={theEditorsStyles.DisplayFontHeading}>
                Input
                {' / '}
                Output
            </div>
            <div>
                <MainEditor
                    onLoad={(editor) => {
                        editorRef.current = editor;
                    }}
                    style={{ marginTop: 5 }}
                    editorWidth="100%"
                    editorHeight="100%"
                    allowFileInput
                />
            </div>
        </div>
    );
};

export { SingleEditor };
